const questions = [
  {
    title: 'Competence',
    inputs: [
      {
        label:
          'Completed training related to the product evaluated (Specify the Product Standard)',
        payloadInput: 'completed_training_remark',
        payloadSelect: 'completed_training',
      },
      {
        label: 'With relevant educational background',
        payloadInput: 'educational_background_remark',
        payloadSelect: 'educational_background',
      },
      {
        label: 'At least 2 years work experience related to the job performed',
        payloadInput: 'two_year_job_experience_remark',
        payloadSelect: 'two_year_job_experience',
      },
      {
        label: 'Knowledge of applicable Technical Regulation',
        payloadInput: 'knowledge_of_tr_remark',
        payloadSelect: 'knowledge_of_tr',
      },
    ],
  },
  {
    title: 'Demonstrable relevant job skills',
    inputs: [
      {
        label:
          'Correctly interprets the requirements of Regulation and Standard',
        payloadInput: 'correctly_interprets_remark',
        payloadSelect: 'correctly_interprets',
      },
      {
        label: 'Can conduct evaluation independently',
        payloadInput: 'evaluation_independently_remark',
        payloadSelect: 'evaluation_independently',
      },
      {
        label: 'Possesses good auditing/inspection skills',
        payloadInput: 'auditing_skills_remark',
        payloadSelect: 'auditing_skills',
      },
      {
        label:
          'Certification activities are done according to technical requirements',
        payloadInput: 'certification_activities_remark',
        payloadSelect: 'certification_activities',
      },
      {
        label: 'Output is delivered within the specified time',
        payloadInput: 'output_is_delivered_remark',
        payloadSelect: 'output_is_delivered',
      },
    ],
  },
  {
    title: 'Quality of Output',
    inputs: [
      {
        label: 'Used correct forms',
        payloadInput: 'used_correct_forms_remark',
        payloadSelect: 'used_correct_forms',
      },
      {
        label: 'Followed applicable GulfTIC procedures',
        payloadInput: 'followed_procedure_remark',
        payloadSelect: 'followed_procedure',
      },
      {
        label: 'Issued Certificate with complete and correct details',
        payloadInput: 'correct_cert_details_remark',
        payloadSelect: 'correct_cert_details',
      },
      {
        label:
          'Professional conduct according to GulfTIC Policies (impartiality, confidentiality, non-discriminatory, key values)',
        payloadInput: 'gulftic_policies_remark',
        payloadSelect: 'gulftic_policies',
      },
    ],
  },
]

export default questions
